function init(){
  const $gtmEventEls = document.querySelectorAll('[data-gtm-event]');

  $gtmEventEls.forEach($gtmEventEl => {
    $gtmEventEl.addEventListener('click', handleClick);
  });
}

function handleClick(evt){
  const $el = evt.target;
  const gtmEvent = $el.getAttribute('data-gtm-event');

  if(gtmEvent === 'material_download'){
    const fileName = $el.getAttribute('data-gtm-file-name');
    const opensInNewWindow = ($el.getAttribute('target').toLowerCase() === '_blank' ? true : false);
    const linkHref = $el.href;

    if(!fileName) throw new Error('GTM material download event: Missing file name attribute');

    const eventData = {
      'event': 'material_download',
      'file_name': fileName
    };

    if(!opensInNewWindow){
      // We are about to leave this document
      // so preventDefault and use the eventCallback to navigate away
      // for that ensure the google_tag_manager exists
      if(!window.google_tag_manager) return;
      evt.preventDefault();

      // Add callBack
      eventData.eventCallback = function(){
        document.location = linkHref;
      };

      // Add callBack timeout
      eventData.eventTimeout = 1000;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(eventData);

    return;
  }

  if(gtmEvent === 'login'){
    // We are about to leave this document
    // so preventDefault and use the eventCallback to navigate away
    // for that ensure the google_tag_manager exists
    if(!window.google_tag_manager) return;
    evt.preventDefault();

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'login',
      'eventCallback': function() {
        $el.closest('form').submit();
      },
      'eventTimeout': 1000
    });

    return;
  }

}

export default {
  init: init,
};
